import { collectIds } from "../processing/search"
import { MAX_SEARCH_HISTORY_SIZE, SEARCH_HISTORY_KEY } from "../variables/search"

const normalizeFromDate = (dates) => {
  if (!dates) return undefined

  if (Array.isArray(dates)) {
    if (dates.length === 0) return undefined
    if (dates.length === 1 && dates[0] == null) return undefined

    return dates[0] == null ? undefined : dates[0]
  }

  return dates == null ? undefined : dates
}

const normalizeToDate = (dates) => {
  if (!dates) return undefined

  if (Array.isArray(dates)) {
    if (dates.length === 0) return undefined
    if (dates.length === 1 && dates[0] == null) return undefined

    const last = dates[dates.length - 1]
    return last == null ? undefined : last
  }

  return dates == null ? undefined : dates
}

export const saveSearchToHistory = (
  selectedDeparture,
  selectedArrival,
  departureDates,
  arrivalDates
) => {
  const departureIds = collectIds(selectedDeparture)
  const arrivalIds = collectIds(selectedArrival)

  if (departureIds.length === 0 && arrivalIds.length === 0) return

  const fromDate = normalizeFromDate(departureDates)
  const toDate = normalizeToDate(arrivalDates)

  try {
    const raw = localStorage.getItem(SEARCH_HISTORY_KEY)
    const history = raw ? JSON.parse(raw) : []

    const existingIndex = history.findIndex(
      (entry) =>
        JSON.stringify(entry.departureIds) === JSON.stringify(departureIds) &&
        JSON.stringify(entry.arrivalIds) === JSON.stringify(arrivalIds)
    )

    if (existingIndex !== -1) {
      // Обновляем существующую запись
      history[existingIndex] = {
        ...history[existingIndex],
        from: selectedDeparture,
        to: selectedArrival,
        fromDate,
        toDate,
        timestamp: Date.now(),
      }

      const updatedEntry = history.splice(existingIndex, 1)[0]
      history.push(updatedEntry)
    } else {
      history.push({
        from: selectedDeparture,
        to: selectedArrival,
        departureIds,
        arrivalIds,
        fromDate,
        toDate,
        timestamp: Date.now(),
      })

      if (history.length > MAX_SEARCH_HISTORY_SIZE) {
        history.shift()
      }
    }

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history))
  } catch (error) {
    console.error("Failed to save search history:", error)
  }
}

export const removeSearchHistoryItem = (timestamp) => {
  try {
    const history = getSearchHistory()

    const updated = history.filter((item) => item.timestamp !== timestamp)

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updated))
  } catch (error) {
    console.error("Failed to remove search history item:", error)
  }
}

export const clearSearchHistory = () => {
  try {
    localStorage.removeItem(SEARCH_HISTORY_KEY)
    return []
  } catch (error) {
    console.error("Failed to clear search history:", error)
  }
}

export const getSearchHistory = () => {
  try {
    const raw = localStorage.getItem(SEARCH_HISTORY_KEY)
    if (!raw) return []

    const parsed = JSON.parse(raw)

    // защита от мусора
    if (!Array.isArray(parsed)) return []

    return parsed.filter(Boolean).sort((a, b) => b.timestamp - a.timestamp) // новые сверху
  } catch (error) {
    console.error("Failed to read search history:", error)
    return []
  }
}
